module.exports = __webpack_public_path__ + "static/media/cross.418bbf49.svg";